import {AddItemResponseStatus_Success_Section_UnlockedTierForSingleItem} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/add_item_status.types';
import {COLORS, ProductCard, Text} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {useCampaignAndSaleBadgeTextByProduct} from '../../shared-deprecated/useCampaignAndSaleBadgeTextByProduct';
import {BadgeList} from '../BadgeList/BadgeList';
import {useBadgesList} from '../BadgeList/useBadgesList';

const DATA_TESTID = 'a2bSuccessSectionSingleItemPriceDecreased';

export const SingleItemPriceDecreased: React.FC<{
  className?: string;
  unlockedTierForSingleItem: AddItemResponseStatus_Success_Section_UnlockedTierForSingleItem;
}> = ({className, unlockedTierForSingleItem}) => {
  const item = unlockedTierForSingleItem.item;

  const {sale, campaignSale} = useCampaignAndSaleBadgeTextByProduct({
    product: item.product,
    selectedSizeId: item.size.id,
    badges: item.badges,
  });

  const badgesList = useBadgesList({
    badges: item.badges,
    sale,
    campaignSale,
    showPriceOverhaulV2SaleLabel: false,
  });

  return (
    <Wrapper data-testid={DATA_TESTID} className={className}>
      <Headline data-testid={`${DATA_TESTID}-Headline`} size="px16">
        {unlockedTierForSingleItem.headline}
      </Headline>

      <StyledProductCard
        product={{
          path: item.product.path,
          image: item.product.primaryBustImage,
          name: item.product.name,
          colorLabel: item.product.colorLabel,
          brand: item.brand.name,
          sizeLabel: item.sizeLabel || '',
          lowStockHint: item.lowStockHint,
          id: item.product.id,
        }}
        totalPrice={item.totalPrice}
        unitPrice={item.unitPrice}
        quantity={{
          quantity: item.quantity,
          maxQuantity: item.availableQuantity,
        }}
        badges={
          <BadgeList badgesList={badgesList} increaseRightSideBorderRadius />
        }
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;

const Headline = styled(Text)`
  line-height: 1.5;
`;

const StyledProductCard = styled(ProductCard)`
  padding: 8px;
  border: 1px solid ${COLORS.Grey3};
  border-radius: 4px;
`;
